import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";
import { Select } from "risa-oasis-ui_v2";
import { OrganizationType } from "../../../../../enums/organizationTypes";
import {
  CONFIGURATION_TYPE_OPTIONS,
  RULE_TYPE_OPTIONS,
} from "../utils/constants";
import { ConfigurationType, RuleType } from "../utils/types";
import ToggleGroup from "./ToggleGroup";

interface MnControlsBarProps {
  organization: string;
  onOrganizationChange: (val: string) => void;
  configurationType: ConfigurationType;
  onConfigurationTypeChange: (val: ConfigurationType) => void;
  drugOptions: { label: string; value: string }[];
  selectedDrugId: string | null;
  onDrugChange: (val: string) => void;
  ruleType: RuleType;
  onRuleTypeChange: (val: RuleType) => void;
}

const MnControlsBar = ({
  organization,
  onOrganizationChange,
  configurationType,
  onConfigurationTypeChange,
  drugOptions,
  selectedDrugId,
  onDrugChange,
  ruleType,
  onRuleTypeChange,
}: MnControlsBarProps) => (
  <div className="flex flex-shrink-0 flex-col gap-3">
    {/* Dropdowns */}
    <div className="flex items-end gap-6">
      <div className="w-1/2">
        <Select
          id="mn-organization"
          options={[
            { label: "NYCBS", value: OrganizationType.NYCBS_DRUG_CONFIG },
            { label: "Astera", value: OrganizationType.ASTERA },
          ]}
          label="Organization"
          placeholder="Select Organization"
          onOptionChange={(option: { value: string }) =>
            onOrganizationChange(option.value)
          }
          defaultValue={organization}
        />
      </div>

      {configurationType === "drug_specific" && (
        <div className="w-1/2">
          <SearchableSelect
            id="mn-drug-name"
            options={drugOptions}
            label="Drug Name"
            placeholder="Select Drug"
            onOptionChange={(option: { name: string; value: string }) =>
              onDrugChange(option.value)
            }
            defaultValue={selectedDrugId || ""}
          />
        </div>
      )}
    </div>

    {/* Toggles — side by side, each taking half the full width */}
    <div className="flex items-end gap-6">
      <div className="flex w-1/2 flex-col gap-1">
        <span className="text-tiny font-medium text-primaryGray-8">
          Configuration Type
        </span>
        <ToggleGroup<ConfigurationType>
          options={CONFIGURATION_TYPE_OPTIONS}
          activeValue={configurationType}
          onChange={onConfigurationTypeChange}
        />
      </div>

      <div className="flex w-1/2 flex-col gap-1">
        <span className="text-tiny font-medium text-primaryGray-8">
          Rule Type
        </span>
        <ToggleGroup<RuleType>
          options={RULE_TYPE_OPTIONS}
          activeValue={ruleType}
          onChange={onRuleTypeChange}
        />
      </div>
    </div>
  </div>
);

export default MnControlsBar;
